module.exports = __webpack_public_path__ + "static/Gotham-BookItalic-d814d9ca298322897facf7e1582039b6.woff";